import { executePost } from "../ServiceMethods";
import { removeUserCredentials, userId } from "../LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../ErrorMessages";

const uid = userId();

export const exploreApi = async (cb) => {
  const data = {
    user_id: 18,
    city_id: 1,
    search_id: "book",
  };

  try {
    const ExploreData = await executePost("/latestvoucherlist", data);
    const exploredata = ExploreData.data ? ExploreData.data : [];
    return exploredata;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
